import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import useOnScreen from "../../../hooks/useOnScreen";
import styles from "./TechnologySection.module.scss";
import governance from "../../../Assets/esg-page/governence.jpg";
import UnpriLogo from "../../../Assets/unpri-logo.png"

import CommunitiesImageNew from "../../../Assets/esg-page/community.jpg";
// import sustainibility from '../../../Assets/esg-page/sustainibility.jpg';
import social from "../../../Assets/esg-page/social.jpg";
import enviroment from "../../../Assets/esg-page/enviroment.jpg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { footerBottomLinks, secondaryLinks } from "../../../constants/links";
export default function TechnologySection() {
	const history = useHistory();
	const ref = useRef(null);

	const [reveal, setReveal] = useState(false);
	const onScreen = useOnScreen(ref);
	const isRouteHandler = (route) => {
		history.push(`/${route}`);
	};
	useEffect(() => {
		if (onScreen) setReveal(onScreen);
	}, [onScreen]);
	return (
		<div data-scroll-section>
			<section className={styles.communtiesAlignment}>
				<div className={styles.TechnologySectionAlignment}>
					<div className="container">
						<div className={styles.gridChildSec}>
							<div className={styles.gridItems}>
								<div className={styles.trasnformingBox}>
									<h1
										className="c-header_title o-h1"
										data-scroll
										data-scroll-speed="1"
										data-scroll-repeat>
										<span
											className={classNames("c-header_title_line", {
												"is-reveal": reveal,
											})}>
											<span
												data-scroll
												data-scroll-speed="1"
												data-scroll-repeat
												data-scroll-position="top">
												SOCIAL
											</span>
										</span>
									</h1>
									<p>
										As residential and commercial property owners and managers,
										strong stakeholder relationships are key.
									</p>
									<div
										data-scroll
										data-scroll-speed="1">
										<h2>Our focus areas include:</h2>
										<ul style={{ paddingLeft: "20px" }}>
											<li>
												Tenant Experience: Offering high-quality, safe, and
												flexible spaces tailored to meet the needs of modern
												tenants.
											</li>
											<li>
												Employee Well-Being: Promoting a diverse and inclusive
												workplace culture where employees can thrive through
												professional development opportunities and well-being
												initiatives.
											</li>
											<li>
												Affordable Mid-Market Housing Solutions: Contributing to
												housing solutions that address societal challenges and
												create accessible living spaces.
											</li>
											<li>
												We are committed to ensuring that there is no modern
												slavery or human trafficking in our supply chains or in
												any part of our business. We operate a Whistleblowing
												Policy so that all employees and stakeholders know they
												can raise concerns about how colleagues are being
												treated, or practices within our business or supply
												chain, without fear of reprisals. LRC has a{" "}
												<a
													className={styles.linkInText}
													href="/modern-slavery-statement">
													Modern Slavery Statement
												</a>
												, which outlines how we work to mitigate the risk of
												enabling modern slavery and human trafficking. Our
												efforts to mitigate this risk are enacted through our
												recruitment practices, through our{" "}
												<a
													className={styles.linkInText}
													href="/whistleblowing-policy">
													Whistleblowing Policy
												</a>
												, via our supply chain compliance procedures, in ongoing
												monitoring and collaboration, and through training of
												relevant team members.
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className={styles.gridItems}>
								<h3
									className="c-header_title o-h1"
									data-scroll
									data-scroll-speed="1"
									data-scroll-repeat>
									<span
										className={classNames("c-header_title_line", {
											"is-reveal": reveal,
										})}>
										<span
											data-scroll
											data-scroll-speed="1"
											data-scroll-repeat
											data-scroll-position="top">
											At LRC Group, we strive to create positive social outcomes
											by fostering inclusivity, community engagement, and
											well-being.
										</span>
									</span>
								</h3>
							</div>
						</div>
					</div>
					<div>
						<div className="container">
							<div className={styles.transformingImageleftAlign}>
								<img
									src={social}
									alt="CommunitiesImage"
									className="flipImage"
									data-scroll
									data-scroll-repeat
								/>
							</div>
						</div>
					</div>
					<div className={styles.mobileTextShow}>
						<h3
							className="c-header_title o-h1"
							data-scroll
							data-scroll-speed="1"
							data-scroll-repeat>
							<span
								className={classNames("c-header_title_line", {
									"is-reveal": reveal,
								})}>
								<span
									data-scroll
									data-scroll-speed="1"
									data-scroll-repeat
									data-scroll-position="top">
									At LRC Group, we strive to create positive social outcomes by
									fostering inclusivity, community engagement, and well-being.
								</span>
							</span>
						</h3>
					</div>
				</div>
			</section>

			<section className={styles.TechnologySectionAlignment}>
				<div className="container">
					<div className={styles.grid}>
						<div className={styles.gridItems}>
							<h3
								className="c-header_title o-h1"
								data-scroll
								data-scroll-speed="1"
								data-scroll-repeat>
								<span
									className={classNames("c-header_title_line", {
										"is-reveal": reveal,
									})}>
									<span
										data-scroll
										data-scroll-speed="1"
										data-scroll-repeat
										data-scroll-position="top">
										Transparency, accountability, and ethical decision-making
										are the cornerstones of our governance framework.
									</span>
								</span>
							</h3>
						</div>
						<div className={styles.gridItems}>
							<div className={styles.trasnformingBox}>
								<h1
									className="c-header_title o-h1"
									data-scroll
									data-scroll-speed="1"
									data-scroll-repeat>
									<span
										className={classNames("c-header_title_line", {
											"is-reveal": reveal,
										})}>
										<span
											data-scroll
											data-scroll-speed="1"
											data-scroll-repeat
											data-scroll-position="top">
											Governance
										</span>
									</span>
								</h1>
								<div
									data-scroll
									data-scroll-speed="1">
									<p>
										At LRC Group, we adhere to high standards to ensure
										long-term trust and integrity.
									</p>
									<p style={{ paddingTop: "10px" }}>
										Our governance efforts include:
									</p>
									<ul style={{ paddingTop: "10px", paddingLeft: "20px" }}>
										<li>
											Sustainability Steering Committee: Set up as an integral
											leadership body to oversee the wider sustainability
											governance framework.
										</li>
										<li>
											Responsible Investment: Integrating ESG considerations
											into our investment decision-making process.
										</li>
										<li>
											Compliance: Upholding compliance with regulation and
											embedding associated practices throughout our
											organisation.
										</li>
										<li>
											Stakeholder Engagement: Maintaining communication with our
											investors, tenants, and partners.
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section>
				<div className="container">
					<div className={styles.transformingImage}>
						<img
							src={governance}
							alt="TransformingImage"
							className="flipImage"
							data-scroll
							data-scroll-repeat
						/>
					</div>
				</div>
				<div className={styles.mobileTextShow}>
					<h3
						className="c-header_title o-h1"
						data-scroll
						data-scroll-speed="1"
						data-scroll-repeat>
						<span
							className={classNames("c-header_title_line", {
								"is-reveal": reveal,
							})}>
							<span
								data-scroll
								data-scroll-speed="1"
								data-scroll-repeat
								data-scroll-position="top">
								Transparency, accountability, and ethical decision-making are
								the cornerstones of our governance framework.
							</span>
						</span>
					</h3>
				</div>
			</section>

			<section className={styles.communtiesAlignment}>
				<div className={styles.TechnologySectionAlignment}>
					<div className="container">
						<div
							className={classNames(
								styles.communitiesMobileViewAlignment,
								styles.gridChildSec
							)}>
							<div className={styles.gridItems}>
								<div className={styles.trasnformingBox}>
									<h1
										className="c-header_title o-h1"
										data-scroll
										data-scroll-speed="1"
										data-scroll-repeat>
										<span
											className={classNames("c-header_title_line", {
												"is-reveal": reveal,
											})}>
											<span
												data-scroll
												data-scroll-speed="1"
												data-scroll-repeat
												data-scroll-position="top">
												Driving Positive Change Together
											</span>
										</span>
									</h1>
									<div
										data-scroll
										data-scroll-speed="1">
										<p>
											Links:
											<a
												style={{
													padding: "10px 0px",
													textTransform: "initial",
												}}
												href={footerBottomLinks.sfdrDisclosure}>
												SFDR Disclosure
											</a>
											<a
												style={{
													paddingBottom: "10px",
													textTransform: "initial",
												}}
												href={footerBottomLinks.paiStatement2024}>
												PAI Statement
											</a>
										</p>
									</div>
								</div>
							</div>
							<div
								className={classNames(
									styles.communtiesMobileAlign,
									styles.gridItems
								)}>
								<h3
									className="c-header_title o-h1"
									data-scroll
									data-scroll-speed="1"
									data-scroll-repeat>
									<span
										className={classNames("c-header_title_line", {
											"is-reveal": reveal,
										})}>
										<span
											data-scroll
											data-scroll-speed="1"
											data-scroll-repeat
											data-scroll-position="top">
											To learn more about our ESG strategy and initiatives, or
											to collaborate with us on creating a positive impact,
											please contact us.
										</span>
									</span>
								</h3>
							</div>
						</div>
					</div>
					<div>
						<div className="container">
							<div className={styles.transformingImageleftAlign}>
								<img
									src={CommunitiesImageNew}
									alt="CommunitiesImageNew"
									className="flipImage"
									data-scroll
									data-scroll-repeat
								/>
							</div>
						</div>
					</div>
					<div className={styles.mobileTextShow}>
						<h3
							className="c-header_title o-h1"
							data-scroll
							data-scroll-speed="1"
							data-scroll-repeat>
							<span
								className={classNames("c-header_title_line", {
									"is-reveal": reveal,
								})}>
								<span
									data-scroll
									data-scroll-speed="1"
									data-scroll-repeat
									data-scroll-position="top">
									LRC creates opportunities for tenants to
								</span>
								<span
									className="italic-class"
									data-scroll
									data-scroll-speed="1"
									data-scroll-position="top"
									data-scroll-repeat>
									{" "}
									connect, interact and create long-lasting relationships.
								</span>
							</span>
						</h3>
					</div>
				</div>
			</section>

			<section className={styles.TechnologySectionAlignment}>
				<div className="container">
					<div className={styles.grid}>
						<div className={styles.gridItems}>
							<h3
								className="c-header_title o-h1"
								data-scroll
								data-scroll-speed="1"
								data-scroll-repeat>
								<span
									className={classNames("c-header_title_line", {
										"is-reveal": reveal,
									})}>
									<span
										data-scroll
										data-scroll-speed="1"
										data-scroll-repeat
										data-scroll-position="top">
										Transparency, accountability, and ethical decision-making
										are the cornerstones of our governance framework.
									</span>
								</span>
							</h3>
						</div>
						<div className={styles.gridItems}>
							<div className={styles.trasnformingBox}>
								<h1
									className="c-header_title o-h1"
									data-scroll
									data-scroll-speed="1"
									data-scroll-repeat>
									<span
										className={classNames("c-header_title_line", {
											"is-reveal": reveal,
										})}>
										<span
											data-scroll
											data-scroll-speed="1"
											data-scroll-repeat
											data-scroll-position="top">
											ENVIRONMENT
										</span>
									</span>
								</h1>
								<div
									data-scroll
									data-scroll-speed="1">
									<p style={{ paddingTop: "10px" }}>
										Our focus areas include:
									</p>
									<ul style={{ paddingTop: "10px", paddingLeft: "20px" }}>
										<li>
											Energy Efficiency Improvements: Deploying a targeted
											transition strategy to enhance the energy performance of
											assets with an aim to reduce the associated carbon
											footprint.
										</li>
										<li>
											Water Consumption Management: Property refurbishment looks
											at the potential to retrofit with 'low-flow' sanitary
											fittings and 'water-saving' fixtures.
										</li>
										<li>
											Biodiversity Enhancement: A strategy to increase the
											provision of on-site green spaces across our portfolio.
										</li>
									</ul>
									<br />
									<p>
										Our Sustainability Risk Management Framework regularly
										monitors climate-related risks and opportunities, including
										physical impacts like flooding and heat stress, and
										transition risks such as energy regulation. We've identified
										potential opportunities to include enhancing asset energy
										efficiency and investing in on-site renewable energy
										generation. In addition to continuous monitoring, our due
										diligence process identifies specific risks and
										opportunities for an asset, so that we can manage them
										effectively post-acquisition. Two of our funds target energy
										efficiency enhancements based on EPC/BER ratings.
									</p>
									<p>
										To improve transparency, we are calculating our portfolio's
										carbon footprint to better understand and target greenhouse
										gas reduction efforts.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section>
				<div className="container">
					<div className={styles.transformingImage}>
						<img
							src={enviroment}
							alt="TransformingImage"
							className="flipImage"
							data-scroll
							data-scroll-repeat
						/>
					</div>
				</div>
				<div className={styles.mobileTextShow}>
					<h3
						className="c-header_title o-h1"
						data-scroll
						data-scroll-speed="1"
						data-scroll-repeat>
						<span
							className={classNames("c-header_title_line", {
								"is-reveal": reveal,
							})}>
							<span
								data-scroll
								data-scroll-speed="1"
								data-scroll-repeat
								data-scroll-position="top">
								The materiality assessment highlighted environmental aspects
								that intersect with our operations.
							</span>
						</span>
					</h3>
				</div>
			</section>

			<div
				className={classNames(
					styles.mobileTextShowLast,
					styles.mobileTextShow
				)}>
				<h3
					className="c-header_title o-h1"
					data-scroll
					data-scroll-speed="1"
					data-scroll-repeat>
					<span
						className={classNames("c-header_title_line", {
							"is-reveal": reveal,
						})}>
						<span
							data-scroll
							data-scroll-speed="1"
							data-scroll-repeat
							data-scroll-position="top">
							LRC partnered with Delos to promote the Stay Well™ program.
						</span>
					</span>
				</h3>
			</div>
			<div style={{ padding: "100px 0px" }}>
				<div className="container">
					<img
						src={UnpriLogo}
						style={{ height: "80px", width: "auto" }}
						alt="Unpri"
					/>
				</div>
			</div>
		</div>
	);
}
